import { getConfig } from "~/org/twilio/one-support-center/shared/osc-env";

const { consoleEndpoint, hostName } = getConfig();

const constants = {
  submitTicketPage: `submit`,
  loginPage: consoleEndpoint,
  redirectToHelpCenterChatUrl: (chatId: string) => `${hostName}/chat/${chatId}`,
  redirectToHelpCenterUrl: hostName,
};

export default constants;
